import svg1 from '@/assets/images/1.svg';
import svg2 from '@/assets/images/2.svg';
import svg3 from '@/assets/images/3.svg';
import svg4 from '@/assets/images/4.svg';
import svg5 from '@/assets/images/5.svg';
import svg6 from '@/assets/images/6.svg';
import svg7 from '@/assets/images/7.svg';
import svg8 from '@/assets/images/qrcode.svg';
import svg9 from '@/assets/images/video.png';
import svg10 from '@/assets/images/coupon.png';

const icons = {
    svg1,
    svg2,
    svg3,
    svg4,
    svg5,
    svg6,
    svg7,
    svg8,
    svg9,
    svg10
};
export default icons;



// WEBPACK FOOTER //
// ./src/layout/components/Sidebar/icon.js